/**
 * Computes the total number of known pages given the exploration state.
 *
 * @param pageTokens - Array of nextTokens captured during forward navigation.
 *   pageTokens[i] is the token needed to fetch page i+1 (index 0 = null sentinel for page 1).
 * @param hasNextToken - Whether the current page's response includes a nextToken.
 * @param currentPageIndex - 1-based index of the page currently being viewed.
 * @returns The total number of pages to display in the pagination control.
 */
export function computePagesCount(
  pageTokens: (string | null)[],
  hasNextToken: boolean,
  currentPageIndex: number,
): number {
  const knownPages = pageTokens.length - 1;
  const isAtFrontier = currentPageIndex >= pageTokens.length - 1;
  return Math.max(1, knownPages + (hasNextToken && isAtFrontier ? 1 : 0));
}
